"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterableDataService = exports.ErrorMessage = exports.FilterableListService = exports.ListStatusCode = exports.FilterableList = exports.FilterableListContainer = void 0;
exports.createFilterableDataService = createFilterableDataService;
exports.createFilterableDataServiceConfig = createFilterableDataServiceConfig;
const app_1 = require("app");
const FilterTypings_1 = require("../Filters/FilterTypings");
function createFilterableDataServiceConfig(type, element, dictionary) {
    const useNewFeature = app_1.AttrService.data(element, 'use-new-feature');
    const starSearchEnabled = app_1.AttrService.data(element, 'star-search-enabled');
    // return serviceConfig
    return {
        culture: app_1.AttrService.data(element, 'culture'),
        dictionary,
        documentTypeAlias: app_1.AttrService.data(element, 'doc-type-alias'),
        pagePath: app_1.AttrService.data(element, 'page-path'),
        pageSize: app_1.AttrService.data(element, 'page-size'),
        searchUrl: app_1.AttrService.data(element, 'search-url'),
        taxonomyTranslationsUrl: app_1.AttrService.data(element, 'taxonomy-url'),
        type,
        useSearchAPIDirectly: useNewFeature && useNewFeature.toLocaleLowerCase() === 'true',
        zeroResultsMessage: app_1.AttrService.data(element, 'zero-message'),
        // Search result specific attributes
        // tslint:disable-next-line:object-literal-sort-keys
        careersLabel: app_1.AttrService.data(element, 'careers-label'),
        country: app_1.AttrService.data(element, 'search-api-country'),
        documentationLabel: app_1.AttrService.data(element, 'documentation-label'),
        downloadsLabel: app_1.AttrService.data(element, 'downloads-label'),
        drawingsLabel: app_1.AttrService.data(element, 'drawings-label'),
        language: app_1.AttrService.data(element, 'search-api-language'),
        productsLabel: app_1.AttrService.data(element, 'products-label'),
        courseLabel: app_1.AttrService.data(element, 'course-label'),
        preselectedLanguagesDocuments: app_1.AttrService.data(element, 'preselected-languages-documents'),
        starSearchEnabled: starSearchEnabled && starSearchEnabled.toLocaleLowerCase() === 'true',
    };
}
function createFilterableDataService(classRef, config) {
    if (!config.useSearchAPIDirectly) {
        return null;
    }
    switch (config.type) {
        case FilterTypings_1.FilterableListTypeEnum.ProductCategories:
        case FilterTypings_1.FilterableListTypeEnum.Products:
        case FilterTypings_1.FilterableListTypeEnum.SearchResults:
        case FilterTypings_1.FilterableListTypeEnum.CaseStudies:
        case FilterTypings_1.FilterableListTypeEnum.News:
        case FilterTypings_1.FilterableListTypeEnum.Downloads:
        case FilterTypings_1.FilterableListTypeEnum.Events:
            return new classRef(config);
        default:
            return null;
    }
}
var FilterableListContainer_1 = require("./FilterableListContainer");
Object.defineProperty(exports, "FilterableListContainer", { enumerable: true, get: function () { return FilterableListContainer_1.FilterableListContainer; } });
var FilterableList_1 = require("./FilterableList");
Object.defineProperty(exports, "FilterableList", { enumerable: true, get: function () { return FilterableList_1.FilterableList; } });
Object.defineProperty(exports, "ListStatusCode", { enumerable: true, get: function () { return FilterableList_1.ListStatusCode; } });
var FilterableListService_1 = require("./FilterableListService");
Object.defineProperty(exports, "FilterableListService", { enumerable: true, get: function () { return FilterableListService_1.FilterableListService; } });
var ErrorMessage_1 = require("./ErrorMessage");
Object.defineProperty(exports, "ErrorMessage", { enumerable: true, get: function () { return ErrorMessage_1.ErrorMessage; } });
var FilterableDataService_1 = require("./FilterableDataService");
Object.defineProperty(exports, "FilterableDataService", { enumerable: true, get: function () { return FilterableDataService_1.FilterableDataService; } });
